<template>
  <div class="navlists">
    <div class="navtitle">{{ navlist.name }}</div>
    <div
      class="listsingle"
      v-for="(i, j) in navlist.list"
      :key="j"
      :class="choose == j ? 'activenavs' : ''"
      @click="choosepath(j, i.index)"
    >
      {{ i.name }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["navlist", "navindex"],
  data() {
    return {
      choose: "0",
    };
  },
  watch: {
    navindex(n, o) {
      this.choose = n;
    },
  },
  methods: {
    choosepath(e, index) {
      this.choose = e;
      this.$emit("returnpath", index);
    },
  },
};
</script>

<style scoped lang="less">
.navlists {
  .activenavs {
    background: rgba(25, 97, 172, 1) !important;
    color: white !important;
    border-radius: 0 0.63vw 0 0;
  }
  .listsingle:hover {
    background: rgba(209, 223, 238, 1);
    border-radius: 0 0.63vw 0 0;
  }
  .listsingle {
    width: 9.38vw;
    height: 2.6vw;
    font-size: 0.94vw;
    color: rgba(6, 25, 45, 1);
    font-weight: 500;
    line-height: 2.6vw;
    padding-left: 1.04vw;
    cursor: pointer;
  }
  .navtitle {
    height: 2.29vw;
    font-weight: 550;
    font-size: 1.25vw;
    color: rgba(6, 25, 45, 1);
    margin-bottom: 0.73vw;
    padding-left: 1.04vw;
  }
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 1.04vw 0px 0px 0px;
  padding-top: 0.68vw;
}
</style>
